var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('router-link',{attrs:{"to":"/customers"}},[_vm._v("Mes clients")]),_c('router-link',{attrs:{"to":"/quotations"}},[_vm._v("Les devis")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }